import * as Yup from 'yup';

export const VERIFY_PATIENT_INITIAL_VALUES = {
  firstName: '',
  lastName: '',
  date: null
};

export const verifyPatientSchema = Yup.object({
  firstName: Yup.string().trim().required('First name is required'),
  lastName: Yup.string().trim().required('Last name is required'),
  date: Yup.string().nullable().required('Date of birth is required')
});
